import { faGrip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import theme from 'theme';

interface IProps {
  children: React.ReactNode;
  keepMounted?: boolean;
  initPosition?: { x: number; y: number };
  open?: boolean;
  style?: CSSProperties;
}

const FloatingWidget = (props: IProps) => {
  const { children, keepMounted, initPosition, open, style } = props;
  const [position, setPosition] = useState({ x: 0, y: 0, ...initPosition });
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) setPosition({ x: 0, y: 0, ...initPosition });
  }, [open, setPosition, initPosition]);

  useEffect(() => {
    const handleResize = () => {
      setPosition((prev) => {
        if (wrapperRef.current) {
          if (prev.x + wrapperRef.current.offsetWidth > window.innerWidth)
            return { x: window.innerWidth - wrapperRef.current.offsetWidth, y: prev.y };
          if (prev.y + 110 > window.innerHeight) return { x: prev.x, y: window.innerHeight - 110 };
        }
        return prev;
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!open && !keepMounted) return null;

  return (
    <div
      ref={wrapperRef}
      style={{
        position: 'absolute',
        top: position.y + 'px',
        left: position.x + 'px',
        display: !open && keepMounted ? 'none' : undefined,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[10],

        borderRadius: '20px 20px 4px 4px',
        overflow: 'hidden',
        ...style,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          cursor: 'move',
          backgroundColor: theme.palette.primary.dark,
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          const x = e.clientX - position.x;
          const y = e.clientY - position.y;
          const onMouseMove = (e: MouseEvent) => {
            let newX = e.clientX - x;
            let newY = e.clientY - y;
            if (newX + wrapperRef.current!.offsetWidth > window.innerWidth)
              newX = window.innerWidth - wrapperRef.current!.offsetWidth;
            if (newY + 110 > window.innerHeight) newY = window.innerHeight - 110;
            if (newX < 0) newX = 0;
            if (newY < 0) newY = 0;
            setPosition({ x: newX, y: newY });
          };
          const onMouseUp = (e: MouseEvent) => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
          };
          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        }}
      >
        <FontAwesomeIcon icon={faGrip} />
      </div>
      {children}
    </div>
  );
};

export default FloatingWidget;
